// libs
import { styled } from '@nykaa/ui-components';

// components
import Button from 'shared/components/Button';

export const Container = styled.div`
  margin: ${({ theme }) => `${theme.spacing.spacing0} auto`};
  max-width: 400px;
  margin-top: ${({ theme }) => theme.spacing.spacing160};

  // header + margin-top + collapsible footer with top margin (50 + 32 + 64)
  min-height: calc(100vh - 146px);
`;

export const HomePageButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borders.radius10};
  width: 264px;
  height: 40px;
  margin: auto;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.buttonLarge}
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.textInversePrimary};
  padding: ${({ theme }) => `${theme.spacing.spacing40} 0`};
`;

export const ImageContainer = styled.div`
  width: 100%;
  text-align: center;

  img {
    text-align: center;
    width: 264px;
    height: 198px;
  }
`;

export const Description = styled.div`
  width: 264px;
  display: flex;
  margin: auto;
  text-align: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.spacing120};
`;
export const Title = styled.h2`
  ${({ theme }) => theme.typography.titleLarge}
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: ${({ theme }) => `${theme.spacing.spacing0} auto`};
`;

export const Subtitle = styled.p`
  ${({ theme }) => theme.typography.bodyLarge}
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.textPrimary};
  letter-spacing: 0.571px;
`;
